import { Spinner } from '@/components/Spinner';
import { useCommissionCategoryDetailList } from './hooks/useCommissionCategoryDetailList';
import { ManageCommissionSlab } from './ManageCommissionSlabs';

export const ManageCommissionSlabContainer = ({
  categoryId,
  categoryDetailId,
  adminCommissionTypeId,
  categoryName,
}: {
  categoryId?: string;
  categoryDetailId?: string;
  adminCommissionTypeId?: string;
  categoryName?: string;
}) => {
  const { commissionCategoryDetailList, isLoading } = useCommissionCategoryDetailList(categoryDetailId ?? '');
  const defaultValues = {
    categoryId: categoryId ?? '',
    adminCommissionTypeId: adminCommissionTypeId ?? '',
    categoryName: categoryName ?? commissionCategoryDetailList?.categoryName,
    categoryDetailId: commissionCategoryDetailList?.categoryDetailId ?? '',
    fromAmount: String(commissionCategoryDetailList?.fromAmount ?? ''),
    toAmount: String(commissionCategoryDetailList?.toAmount ?? ''),
    commissionValue: String(commissionCategoryDetailList?.commissionValue ?? ''),
    commissionPercentageType: commissionCategoryDetailList?.commissionPercentageType ?? '',
    minCommissionValue: String(commissionCategoryDetailList?.minCommissionValue ?? ''),
    maxCommissionValue: String(commissionCategoryDetailList?.maxCommissionValue ?? ''),
  };
  if (isLoading) return <Spinner />;
  return <ManageCommissionSlab defaultValues={defaultValues} />;
};
